import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { LoggingService } from 'core/logging/logging.service';
import { CriticalError, TrivialError } from './error';
import { ErrorService } from './error.service';

@Injectable()
export class CustomErrorHandler implements ErrorHandler
{
  constructor(private injector: Injector) { }

  public handleError(error): void
  {
    const loggingService = this.injector.get(LoggingService);
    const errorService = this.injector.get(ErrorService);

    if (error instanceof CriticalError ||
        error instanceof TrivialError) {
      errorService.add(error);
      errorService.flushAll();
    }

    else {
      const message = error.message ? error.message : error.toString();
      try {
        loggingService.log('ErrorHandler', 'ERROR', message);
      }
      catch (ex) {}  // keinen Fehler werfen, wenn Logging dann nichts bringt

      throw error; // muss erneut geworfen werden, sonst wird der Error
                   // verschluckt --> keine Consolenausgabe, Listener, ...
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/error/error-handler.ts